module.exports = __webpack_public_path__ + "img/couponDoctor_f.efc2cd41.png";